import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, FormArray } from '@angular/forms';
import * as fromStore from '../../../../store';
import { Store } from '@ngrx/store';
import * as StopoverHotelsAction from '@ibe/store/actions/stopover-hotels.actions';
import { SidebarService } from '@ibe/services/ui';
import { Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { INDRABookingComService } from '@ibe.services/booking-com.indra.service';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';

@Component({
	selector: 'app-partner-hotel-filter',
	templateUrl: './partner-hotel-filter.indra.component.html',
	styleUrls: ['./partner-hotel-filter.component.scss']
})
export class INDRAPartnerHotelFilterComponent implements OnInit, OnDestroy {

	isAlive = true;

	optionsPrice = [
		{ value: '', label: 'Select price range' },
		{ value: '0-50' }, // label: '0€ ~ 50€' 
		{ value: '50-100' }, // label: '50€ ~ 100€'
		{ value: '100-150' }, // label: '100€ ~ 150€'
		{ value: '150-200' }, // label: '150€ ~ 200€'
		{ value: '200-' }, // label: '200€ +'
	];

	optionsStars = [
		{ value: '', label: 'Select stars' },
		{ value: '1', label: '1 star' },
		{ value: '2', label: '2 stars' },
		{ value: '3', label: '3 stars' },
		{ value: '4', label: '4 stars' },
		{ value: '5', label: '5 stars' }
	];

	selectedPrice: String = '';
	selectedStars: String = '';
	property;
	propertyFilter;
	facilities;
	facilitiesFilter;

	partnerHotelStopoverFilter$: Observable<any> = this.store.select(fromStore.getStopoversHotelsFilters);
	partnerHotelStopoverFilter;

	constructor(
		private bookingComService: INDRABookingComService,
		private store: Store<fromStore.State>,
		private sidebarService: SidebarService,
		private currencyService: INDRACurrencyService,
		private ibeAdminService: INDRAIbeAdminService
	) {
		const currencyUnit = this.currencyService.INDRA_getCurrencySymbol().unit;

		this.property = this.bookingComService.facilitiesAndProperties.properties;
		this.facilities = this.bookingComService.facilitiesAndProperties.facilities;
		this.optionsPrice.forEach(price => {
			if (price.value) {
				const minPrice = price.value.split('-')[0];
				const maxPrice = price.value.split('-')[1];

				if (minPrice && maxPrice) {
					price.label = `${minPrice}${currencyUnit} ~ ${maxPrice}${currencyUnit}`;
				} else if (minPrice && !maxPrice) {
					price.label = `${minPrice}${currencyUnit} +`;
				}
			}
		});

		this.INDRA_translateLOVs();
	}

	ngOnInit() {
		this.propertyFilter = this.property.filter(cur => cur.allow);
		this.facilitiesFilter = this.facilities.filter(cur => cur.allow);

		this.partnerHotelStopoverFilter$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (!value) return;

				this.partnerHotelStopoverFilter = value;

				this.selectedPrice = value.minPrice ? `${value.minPrice}-${value.maxPrice}` : '';
				this.selectedStars = value.stars;

				this.propertyFilter = this.populateFilters(value.propertyType, this.propertyFilter);
				this.facilitiesFilter = this.populateFilters(value.hotelFacilities, this.facilitiesFilter);
			});
	}

	ngOnDestroy() {
		this.isAlive = false;
	}

	private populateFilters(filterState, filter) {
		for (const value of filterState) {
			for (const item of filter) {
				if (item.key == value || item.id == value) {
					item.checked = true;
				}
			}
		}

		return filter;
	}

	private hasChanged(newFilter) {
		newFilter.hotelFacilities.sort();
		newFilter.propertyType.sort();

		for (const key in this.partnerHotelStopoverFilter) {
			if (Array.isArray(this.partnerHotelStopoverFilter[key])) {
				if (JSON.stringify(this.partnerHotelStopoverFilter[key]) !== JSON.stringify(newFilter[key])) {
					return true;
				}
			} else if (key !== 'changed') {
				if (this.partnerHotelStopoverFilter[key] !== newFilter[key]) {
					return true;
				}
			}
		}

		return false;
	}

	INDRA_applyFilters() {
		let maxPrice = '';
		let minPrice = '';

		if (this.selectedPrice) {
			minPrice = this.selectedPrice.split('-')[0];
			maxPrice = this.selectedPrice.split('-')[1];
		}

		const data = {
			minPrice: minPrice,
			maxPrice: maxPrice,
			stars: this.selectedStars,
			hotelFacilities: this.facilitiesFilter.filter(item => item.checked).map(item => item.id),
			propertyType: this.propertyFilter.filter(item => item.checked).map(item => item.key),
			changed: true,
		};

		if (this.partnerHotelStopoverFilter) {
			data.changed = this.hasChanged(data);
		}

		this.store.dispatch(new StopoverHotelsAction.PutStopoverFiltersAction(data));

		this.sidebarService.previousSidebar();
	}

	INDRA_translateLOVs() {
		this.optionsPrice[0].label = this.INDRA_getTranslationKey('extrasSidebar.findHotels.text.selectPriceRange');
		const stars = this.INDRA_getTranslationKey('extrasSidebar.findHotels.text.stars').toLowerCase();
		const star = this.INDRA_getTranslationKey('extrasSidebar.findHotels.text.star');
		this.optionsStars = [
			{ value: '', label: this.INDRA_getTranslationKey('extrasSidebar.findHotels.text.selectStars') },
			{ value: '1', label: `1 ${star}` },
			{ value: '2', label: `2 ${stars}` },
			{ value: '3', label: `3 ${stars}` },
			{ value: '4', label: `4 ${stars}` },
			{ value: '5', label: `5 ${stars}` }
		];
	}

	INDRA_getTranslationKey(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}
}
